import { useConfirm } from './useConfirm'
import { useUpdateDemoSchoolGroup } from './mutations/useUpdateDemoSchoolGroup'

const useConfirmRemoveDemoSchoolGroup = (schoolGroup) => {
  const { confirm } = useConfirm()
  const { post } = useUpdateDemoSchoolGroup()

  const confirmRemoveDemoSchoolGroup = async (onSuccess) => {
    const confirmed = await confirm({
      title: schoolGroup.name,
      text: 'Är du säker på att du vill dölja denna grupp i ditt lärarrum? Böcker som du har delat med gruppen kommer att döljas för eleverna.',
      confirmText: 'Ja, dölj gruppen',
      cancelText: 'Avbryt',
    })

    if (!confirmed) return

    const res = await post({
      connected: false,
      id: schoolGroup.id,
    }, 'Gruppen döljs från ditt lärarrum. Du kan återskapa den från demoklassen.')

    if (res.success && typeof onSuccess == 'function') {
      onSuccess()
    }
  }

  return { confirmRemoveDemoSchoolGroup }
}

export { useConfirmRemoveDemoSchoolGroup }
